export default {
  isVisible: false,

  icon: '',
  iconColor: '',

  title: '',
  message: '',
  errorList: [],
};
